'use client';

import { cafeBazaarAppUrl, myketAppUrl } from '@repo/config';
import { getEdgeTrace } from '@repo/web-chrome/lib/edge-trace';
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
import { StoreBadge } from './app-store-badge-row';

interface IIranianStoreBadgeRowProps {
  locale: string;
  className?: string;
}

export function IranianStoreBadgeRow({
  locale,
  className,
}: IIranianStoreBadgeRowProps): React.JSX.Element | null {
  const isPersian = locale === 'fa';
  const [show, setShow] = useState(isPersian);

  useEffect(() => {
    if (show) {
      return;
    }
    let active = true;
    getEdgeTrace().then(({ country }) => {
      if (active && country === 'IR') {
        setShow(true);
      }
    });
    return () => {
      active = false;
    };
  }, [show]);

  if (!show) {
    return null;
  }

  const eyebrow = isPersian ? 'دریافت از' : 'Get it on';
  const cafeBazaarLabel = isPersian ? 'کافه‌بازار' : 'Cafe Bazaar';
  const myketLabel = isPersian ? 'مایکت' : 'Myket';

  return (
    <div className={clsx('flex flex-row items-center gap-2 sm:gap-3', className)}>
      <StoreBadge href={cafeBazaarAppUrl} eyebrow={eyebrow} label={cafeBazaarLabel} />
      <StoreBadge href={myketAppUrl} eyebrow={eyebrow} label={myketLabel} />
    </div>
  );
}
